import React from 'react'
import { START_SELLING, ARTIST_PROFILE_MANAGEMENT_LINK } from '../../helpers/constants'
import type { SectionProps } from './Section'
import Section from './Section'

const Component = (props: SectionProps): React.ReactElement<React.ComponentProps<any>, any> => {
  const { currentSection, onToggle, section } = props
  return (
    <Section
      name={START_SELLING}
      title='What do I need to do to start selling my artwork on Saatchi Art?'
      {...{
        currentSection,
        onToggle,
        section,
      }}
    >
      <p>
        We’re thrilled that you’d like to sell your work on Saatchi Art! In order to get started,
        you will first need to create an artist account, and then upload a government-issued photo
        ID. Once you are approved, you can begin to upload artwork for sale, and you’re all set!
        Also, don’t forget to take some time to fill in your profile with information about
        yourself, such as where you studied, your exhibition history, and an artist’s statement.
        This kind of information can increase your chances of selling work and being noticed by our
        curators.{' '}
        <a
          data-type='link'
          target='_blank'
          rel='noopener noreferrer'
          href={ARTIST_PROFILE_MANAGEMENT_LINK}
        >
          Learn More
        </a>
      </p>
    </Section>
  )
}

export default Component